<template>
  <tr class="data-table-top-header">
    <slot />
  </tr>
</template>

<style>
.table > thead > tr.data-table-top-header > th {
  border: none;
  border-spacing: 2px;
}
</style>

<script>
export default {
  name: 'DataTableTopHeaderRow'
}
</script>